import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit
} from '@angular/core';
import { UserService as NgxUserService } from '@go-modules/services/user/user.service';
import { BehaviorSubject } from 'rxjs';
import { NgxGroupService } from '@go-modules/services/group/group.service';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import { Account } from '@go-modules/interfaces/account';
import { RouterService } from '@go-modules/services/router/router.service';

@Component({
	selector: 'license-management',
	templateUrl: './license-management.component.html',
	styleUrls: ['./license-management.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LicenseManagementComponent implements OnInit {
	public orgId: number | null = null;
	public myAccount: Account;
	public showMenu: BehaviorSubject<boolean> = new BehaviorSubject(false);

	constructor (
		private routerService: RouterService,
		private groupService: NgxGroupService,
		private ngxUserService: NgxUserService,
		@Inject(selectedServiceToken) public selectedService: SelectedService
	) {}

	public ngOnInit () {
		this.orgId = this.routerService.getCurrentParams().orgId || null;
		this.myAccount = this.selectedService.getAccount();
		let expiredLicenses;
		if (this.orgId == null) {
			expiredLicenses = this.ngxUserService.getExpiredLicenses();
		} else {
			expiredLicenses = this.groupService.getExpiredLicenses(this.orgId);
		}
		expiredLicenses.pipe().subscribe((value) => {
			this.showMenu.next(value.licenses.length > 0);
		});
	}
}
